
import PulseButton from '../pulse-button.vue'
import PulseCategory from '../pulse-category.vue'

export default {
  components: {PulseButton, PulseCategory},
  props: {
    entityId: {type: String, required: true},
    steps: {type: Array, required: true},
    name: {type: String, required: true},
    total: {type: Number, required: true},
  },
  computed: {
    can_expand(){
      return this.steps.length > 5
    },
    button_text() {
      return `Filter to view all ${this.name} activity`
    }
  }
}
